import React from "react";
import Label from "@component/form/Label";

const InputArea = ({
  register,
  defaultValue,
  name,
  label,
  type,
  placeholder,
  Icon,
  required,
  pattern,
  readOnly,
  title,
  autoComplete,
  error
}) => {
  const hasError = error && error.message;

  return (
    <>
      <Label required={required} label={label} />
      <div className="relative">        {Icon && (
        <div className="absolute inset-y-0 left-0 pl-2 sm:pl-3 flex items-center pointer-events-none">
          <span className={`text-sm sm:text-base transition-colors duration-200 ${hasError ? 'text-red-500' : 'text-gray-800 focus-within:text-gray-900'
            }`}>
            <Icon />
          </span>
        </div>
      )}<input
          {...register(`${name}`, {
            required: required ? `${label} is required!` : false,
            pattern: pattern ? {
              value: pattern,
              message: `Please enter a valid ${label.toLowerCase()}`
            } : undefined,
          })}
          defaultValue={defaultValue}
          type={type}
          placeholder={placeholder}
          name={name}
          readOnly={readOnly}
          title={title}
          autoComplete={autoComplete}
          className={`
            py-2 px-3 sm:px-4 w-full appearance-none border text-sm transition duration-200 focus:ring-2 ease-in-out bg-white rounded-md sm:rounded-lg placeholder-gray-500 min-h-10 sm:min-h-11 md:min-h-12 h-10 sm:h-11 md:h-12
            ${Icon ? 'pl-8 sm:pl-10 pr-3 sm:pr-4' : ''}
            ${hasError
              ? 'border-red-300 focus:border-red-500 focus:ring-red-200 text-red-900'
              : 'border-gray-200 focus:border-emerald-500 focus:ring-emerald-200 text-gray-900'
            }
            ${readOnly ? 'bg-gray-50 cursor-not-allowed' : ''}
          `}
        />        {hasError && (
          <div className="absolute inset-y-0 right-0 pr-2 sm:pr-3 flex items-center pointer-events-none">
            <svg className="h-4 w-4 sm:h-5 sm:w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
        )}
      </div>
    </>
  );
};

export default InputArea;
